module.exports = __webpack_public_path__ + "img/phoneIcon.6cc7786a.png";